import Descriptions from '~/components/Descriptions';
import type { OAISchema } from '~/types/openapi';

type Props = {
  options: OAISchema['MarketProductDetailsResponseV2']['options'];
};

const ProductOrderInfo = ({ options }: Props) => {
  const defaultOption =
    options.filter(({ isDefault }) => isDefault)[0] || options[0];
  const isOrderPerMultipleQuantity = defaultOption.orderPerMultipleQuantity > 1;

  if (
    !isOrderPerMultipleQuantity &&
    !defaultOption.isMinimumOrderQuantityEnabled &&
    !defaultOption.isIndividualQuantityLimitEnabled
  ) {
    return <></>;
  }

  return (
    <Descriptions labelMinWidth={50} title="주문정보">
      <Descriptions.Item label="수량제한">
        {defaultOption.minimumOrderQuantity &&
          defaultOption.minimumOrderQuantity > 0 && (
            <>
              {defaultOption.minimumOrderQuantity}개 부터 주문가능
              <br />
            </>
          )}
        {defaultOption.individualQuantityLimit &&
          defaultOption.individualQuantityLimit > 0 && (
            <>
              최대 {defaultOption.individualQuantityLimit.toLocaleString()}
              개까지 (하루 기준)
              <br />
            </>
          )}
        {defaultOption.orderPerMultipleQuantity &&
          defaultOption.orderPerMultipleQuantity > 1 && (
            <>{defaultOption.orderPerMultipleQuantity}개 단위로 구매 가능</>
          )}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ProductOrderInfo;
